import { useCallback } from "react";
import { loginRequest, setLogoutFlag } from "@/authConfig.ts";
import customHistory from "@/core/customHistory.ts";
import { useMsal } from "@azure/msal-react";
import { authTelemetry } from "@/app/services/authTelemetry";

export const useLogout = () => {
    const { instance } = useMsal();

    const logout = useCallback(async () => {
        // Track session end due to user logout
        authTelemetry.trackSessionEnd('user_logout');

        // Set logout flag to indicate user explicitly logged out
        setLogoutFlag();

        await instance.logoutRedirect({
        ...loginRequest,
        postLogoutRedirectUri: window.location.origin,
        onRedirectNavigate: () => {
            setTimeout(() => {
            customHistory.push('/');
            }, 100);
            return false;
        }
        });
    }, [instance]);

    return logout;
}